import { Navigate } from 'react-router-dom';

import { useAuthStore } from '@/store/authStore';

interface RoleRouteProps {
  allowedRoles: string[];
  children: React.ReactNode;
}

export function RoleRoute({ allowedRoles, children }: RoleRouteProps) {
  const user = useAuthStore((state) => state.user);

  if (!user || !allowedRoles.includes(user.role)) {
    return <Navigate to='/dashboard' replace />;
  }

  return <>{children}</>;
}
